import { createRouteRef } from '@backstage/core-plugin-api';

export const nvdRouteRef = createRouteRef({
  id: 'nvd',
});